// Access token хранится в памяти + sessionStorage (не localStorage — не переживает закрытие вкладки).
// Refresh token — HttpOnly cookie, клиент его не видит. При 401 api.js дергает /auth/refresh.

const STORAGE_KEY = 'blot_access_token';

let accessToken = sessionStorage.getItem(STORAGE_KEY) || null;
const listeners = new Set();

const notify = () => {
  for (const fn of listeners) fn(accessToken);
};

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token || null;
  if (token) sessionStorage.setItem(STORAGE_KEY, token);
  else sessionStorage.removeItem(STORAGE_KEY);
  notify();
};

export const clearAccessToken = () => setAccessToken(null);

export const onTokenChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
